export default __webpack_public_path__ + "static/990-b605313ac806905e636f12e094db17a5.gif";